import * as Api from "./Api";

export default {
    show(case_guid) {
        return Api.client.get(`/getWzCaseByCaseGuid/${case_guid}`);
    },
};